﻿import 'owl.carousel';

shvenergy.topreviews = (function ($) {
    "use strict";

    var topReviewCarousels = $(".top-review-carousel");

    var topReviewCarouselSettings = {
        stagePadding: 0,
        loop: false,
        margin: 16,
        nav: false,
        dots: true,
        items: 1,
        autoHeight: true,
        responsiveClass: false,
        responsive: {
            0: {
                stagePadding: 64,
            },
            768: {
                stagePadding: 64,
            },
            992: {
                stagePadding: 0,
            },
            1310: {
                stagePadding: 0,
            }
          }
    }

    var topReviewMqls = [// list of window.matchMedia() queries
        window.matchMedia("(min-width: 2px)"),
    ];

    function topReviewMediaqueryresponse(mql) {
        if (topReviewMqls[0].matches) {
            //console.log("Create");
            topReviewCarousels.each(function (index, value) {
                var owlContainer = $(this);
                owlContainer.addClass("owl-carousel").owlCarousel(topReviewCarouselSettings);
            });


        }

        if (topReviewMqls[1].matches) {
            //console.log("Destroy");
            topReviewCarousels.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            topReviewCarousels.find('.owl-stage-outer').children().unwrap();
        }
    }

    for (var i = 0; i < topReviewMqls.length; i++) { // loop through queries
        topReviewMediaqueryresponse(topReviewMqls[i]); // call handler function explicitly at run time
        topReviewMqls[i].addListener(topReviewMediaqueryresponse); // call handler function whenever the media query is triggered
    }

})(jQuery);